<template>
  <template v-if="bool">
    <Icon icon="fa-pro-solid:circle-check" class="text-success" />
  </template>
  <template v-else>
    <Icon icon="fa-pro-solid:circle-xmark" />
  </template>
</template>

<script>
export default {
  props: {
    bool: Boolean,
  }
}
</script>

<style lang="scss">
</style>